import React from "react"

import { Link } from 'react-router-dom';
import {List} from 'antd';


const FooterMenu = () => {
    return (
                <div>
                <h3 className="footer-title">Company</h3>
                  <List>
                      <List.Item>
                          <Link to="/">Home</Link>
                      </List.Item>
                      <List.Item>
                          <Link to="/aboutus">About</Link>
                      </List.Item>
                      <List.Item>
                          <Link to="/faq">FAQ</Link>
                      </List.Item>
                      <List.Item>
                          <Link to="/contactus">Contact</Link>
                      </List.Item>
                  </List>
                </div>
    );
  }
  
  export default FooterMenu;